/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  DecisionDto,
  GetAllDecisionsParams,
  IReadOnlyListOfDecisionDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all decisions enumeration values, with an optional filter.
 */
export const getAllDecisions = (
    params?: GetAllDecisionsParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfDecisionDto>>,) => {
      return customInstance<IReadOnlyListOfDecisionDto>(
      {url: `/incident-management/decisions`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the Decision identified by the route id.
 */
export const getDecisionById = (
    id: number,
 options?: SecondParameter<typeof customInstance<DecisionDto>>,) => {
      return customInstance<DecisionDto>(
      {url: `/incident-management/decisions/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllDecisionsResult = NonNullable<Awaited<ReturnType<typeof getAllDecisions>>>
export type GetDecisionByIdResult = NonNullable<Awaited<ReturnType<typeof getDecisionById>>>
